export const validateDate = (datetime: string) => {
    const date = new Date(datetime);
    return !Number.isNaN(date.getTime());
};
